<template>
  <div class="course-list-wtxh scroll-box" @scroll="scrollBox($event)">
    <TopBarWtxh />
    <!-- 筛选栏 - 领域/专业 -->
    <div class="filter-top">
      <div class="filter-item" @click="showCategory = !showCategory; showSubCategory = false">
        <span>{{ categoryText }}</span>
        <img class="arrow-icon" :class="{ open: showCategory }" src="@/assets/arrows-down-grey.png" />
      </div>
      <div class="filter-item" @click="showSubCategory = !showSubCategory; showCategory = false">
        <span>{{ subCategoryText }}</span>
        <img class="arrow-icon" :class="{ open: showSubCategory }" src="@/assets/arrows-down-grey.png" />
      </div>
      <!-- 分类下拉 - 领域 -->
      <div class="dropdown-panel" v-if="showCategory" @click.stop>
        <div
          class="dropdown-item"
          :class="{ active: selectedCategoryId === 0 }"
          @click="selectCategory(null)"
        >全部</div>
        <div
          class="dropdown-item"
          :class="{ active: selectedCategoryId === item.id }"
          v-for="item in category"
          :key="item.id"
          @click="selectCategory(item)"
        >{{ item.name }}</div>
      </div>
      <!-- 分类下拉 - 专业 -->
      <div class="dropdown-panel" v-if="showSubCategory" @click.stop>
        <div
          class="dropdown-item"
          :class="{ active: selectedSubId === 0 }"
          @click="selectSubCategory(null)"
        >全部</div>
        <div
          class="dropdown-item"
          :class="{ active: selectedSubId === item.id }"
          v-for="item in subCategoryList"
          :key="item.id"
          @click="selectSubCategory(item)"
        >{{ item.name }}</div>
      </div>
    </div>
    <!-- 筛选栏 - 元宇宙 -->
    <div class="filter-yyz-bar">
      <span class="yyz-label">是否支持元宇宙跨空间培训：</span>
      <span class="yyz-option" :class="{ active: yyzIndex === '1' }" @click="changYyzValue('1')">是</span>
      <span class="yyz-option" :class="{ active: yyzIndex === '2' }" @click="changYyzValue('2')">否</span>
    </div>
    <!-- 课程网格 -->
    <div class="grid-wrap">
      <ul class="course-grid" v-if="list.length">
        <li
          class="course-card"
          v-for="item in list"
          :key="item.id"
          @click="$router.push('/recordedInfo/' + item.id)"
        >
          <div class="card-cover">
            <img :src="item.image" />
          </div>
          <div class="card-info">
            <p class="card-name">{{ item.name }}</p>
            <p class="card-intro">{{ item.intro || '' }}</p>
            <!-- <div class="card-teacher" v-if="item.teacher_name">
              <img
                class="teacher-avatar"
                v-if="item.teacher_avatar"
                :src="item.teacher_avatar"
              />
              <img
                class="teacher-avatar"
                v-else
                src="@/assets/per_img.png"
              />
              <span class="teacher-name">主讲老师：{{ item.teacher_name }}</span>
            </div> -->
          </div>
        </li>
      </ul>
      <div class="nodata" v-if="loaded && list.length === 0">
        <img class="nodata-img" :src="require('@/assets/no-data.png')" />
        <p class="nodata-text">暂无课程</p>
      </div>
    </div>
    <BottomWtxhM />
  </div>
</template>

<script>
import TopBarWtxh from "@/m/common/topBarWtxh.vue";
import BottomWtxhM from "@/m/common/bottomWtxhM.vue";

export default {
  name: "CourseListWtxh",
  components: {
    TopBarWtxh,
    BottomWtxhM,
  },
  data() {
    return {
      category: [],
      subCategoryList: [],
      selectedCategoryId: 0,
      selectedSubId: 0,
      categoryText: "领域",
      subCategoryText: "专业",
      showCategory: false,
      showSubCategory: false,
      yyzIndex: '1',
      page: 1,
      pre_page: 10,
      list: [],
      more: false,
      loaded: false,
    };
  },
  mounted() {
    this.getCategory();
    this.getCourseList();
  },
  methods: {
    getCategory() {
      this.$axios.post(`/v1/course/category`).then((res) => {
        this.category = res.data;
      });
    },
    selectCategory(item) {
      if (item) {
        this.selectedCategoryId = item.id;
        this.categoryText = item.name;
        this.subCategoryList = item.child || [];
      } else {
        this.selectedCategoryId = 0;
        this.categoryText = "领域";
        this.subCategoryList = [];
      }
      this.selectedSubId = 0;
      this.subCategoryText = "专业";
      this.showCategory = false;
      this.page = 1;
      this.list = [];
      this.getCourseList();
    },
    selectSubCategory(item) {
      if (item) {
        this.selectedSubId = item.id;
        this.subCategoryText = item.name;
      } else {
        this.selectedSubId = 0;
        this.subCategoryText = "专业";
      }
      this.showSubCategory = false;
      this.page = 1;
      this.list = [];
      this.getCourseList();
    },
    getCourseList() {
      if (this.yyzIndex === '2') {
        this.list = [];
        this.more = false;
        this.loaded = true;
        return;
      }
      let cid = this.selectedSubId || this.selectedCategoryId;
      this.$axios
        .post(`/v1/course/list`, {
          category_id: cid,
          page: this.page,
          pre_page: this.pre_page,
        })
        .then((res) => {
          this.list.push(...res.data.data);
          this.more = res.data.total > this.list.length;
          this.loaded = true;
        });
    },
    changYyzValue(val) {
      this.yyzIndex = val;
      this.page = 1;
      this.list = [];
      this.getCourseList();
    },
    scrollBox(e) {
      if (
        e.target.scrollHeight - e.target.clientHeight <= e.target.scrollTop + 2 &&
        this.more
      ) {
        this.page++;
        this.getCourseList();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.course-list-wtxh {
  background-color: rgba(247, 251, 252, 1);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.filter-top {
  background-color: #fff;
  padding: 20px 32px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 88px;
  z-index: 100;
}
.filter-yyz-bar {
  background-color: #fff;
  padding: 0 32px 20px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 170px;
  z-index: 99;
}
.filter-item {
  display: flex;
  align-items: center;
  margin-right: 40px;
  span {
    font-size: 30px;
    font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
    color: rgba(51, 51, 51, 1);
    line-height: 42px;
  }
}
.arrow-icon {
  width: 24px;
  height: 18px;
  margin-left: 8px;
  transition: transform 0.2s;
  &.open {
    transform: rotate(180deg);
  }
}
.yyz-label {
  font-size: 30px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  color: rgba(51, 51, 51, 1);
  line-height: 42px;
  white-space: nowrap;
}
.yyz-option {
  display: inline-block;
  padding: 4px 24px;
  font-size: 26px;
  color: #999;
  background: #f5f5f5;
  border-radius: 6px;
  border: 1px solid #f5f5f5;
  margin-left: 16px;
  white-space: nowrap;
  &.active {
    color: #e86614;
    border-color: #e86614;
    background: rgba(232, 102, 20, 0.08);
  }
}
.dropdown-panel {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  max-height: 600px;
  overflow-y: auto;
  padding: 10px 0;
  z-index: 889;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.dropdown-item {
  padding: 24px 32px;
  font-size: 28px;
  color: #333;
  &.active {
    color: #254ed4;
  }
  &:active {
    background: #f5f5f5;
  }
}
.grid-wrap {
  padding: 20px 32px 40px;
  flex: 1;
}
.course-grid {
  display: flex;
  flex-wrap: wrap;
  column-gap: 26px;
  row-gap: 28px;
}
.course-card {
  width: 330px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 6px 0px rgba(219, 219, 219, 0.5);
  overflow: hidden;
}
.card-cover {
  width: 330px;
  height: 200px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px 8px 0 0;
  }
}
.card-info {
  padding: 20px;
}
.card-name {
  font-size: 28px;
  font-family: PingFangSC-Medium, "PingFang SC", sans-serif;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-intro {
  font-size: 24px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  color: rgba(153, 153, 153, 1);
  line-height: 34px;
  margin-top: 8px;
  min-height: 102px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.card-teacher {
  display: flex;
  align-items: center;
  margin-top: 16px;
}
.teacher-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.teacher-name {
  margin-left: 10px;
  font-size: 24px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  color: rgba(153, 153, 153, 1);
  line-height: 34px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nodata {
  width: 574px;
  padding-top: 20px;
  margin: 0 auto;
  text-align: center;
  .nodata-img {
    width: 100%;
    height: auto;
  }
  .nodata-text {
    font-size: 26px;
    color: #999;
    padding-top: 40px;
  }
}
</style>
